import { WalletType, WalletTypeV1 } from "../../shared";
import { z } from "zod";

export const WalletTypeParamsSchema = z.object({
  type: z.string().nullable().optional(),
  marginMode: z.string().nullable().optional(),
  productType: z.string().nullable().optional(),
  accountType: z.string().nullable().optional(),
  subType: z.string().nullable().optional(),
  unified: z.boolean().nullable().optional(),
  future: z.boolean().nullable().optional(),
});

export type WalletTypeParams = z.infer<typeof WalletTypeParamsSchema>;

export type WalletTypesV1Config = WalletTypesConfig<WalletTypeV1>;

export type WalletTypesConfig<T = WalletType> = {
  send_wallet_type: {
    [cex: string]: T | undefined;
  };
  /**
   * @description
   * even if the transfer is not allowed or there's only one wallet type for trade and/or send,
   * we must put it in the mapping, because balances on send/trade pages are displayed using these values
   */
  transfer_wallet_types: {
    [cex: string]: T[] | undefined;
  };
  external_to_internal_wallet_types: Record<string, Record<string, string>>;
  internal_to_external_wallet_types: {
    [cex: string]: {
      [internalWalletType: string]: string | undefined;
    };
  };
  external_wallet_types_parameters: {
    [cex: string]: {
      [internalWalletType: string]: WalletTypeParams[] | undefined;
    };
  };
};
